import React from "react";
import { Link } from "react-router-dom";

export default function Blog() {
  return (
    <div className="page-content">
      <h1>Latest Articles</h1>
      <ul>
        <li>
          <Link to="/blog/tips-for-getting-your-coffee">Tips for Getting Your Coffee</Link>
        </li>
      </ul>
    </div>
  );
}
